// extracted by mini-css-extract-plugin
export var backdropBlur = "_i0-0";
export var contentCard = "_i0-5";
export var frame = "_i0-2";
export var image = "_i0-4";
export var imagePane = "_i0-3";
export var modal = "_i0-1";